<!-- TEMPLATE -->
<template>
  <div class="dean-sidemenu-column-item">
    <!--<dean-tooltip
      class="tooltip"
      v-if="disabled">
      <span
        slot="activator"
        class="link disabled">
        <dean-icon
          class="icon-custom"
          :glyph="icon"
          height="15"
          width="15">
        </dean-icon>
        <slot></slot>
        <dean-icon
          class="icon-right"
          :glyph="forward"
          height="15"
          width="15">
        </dean-icon>
      </span>
      Niet actief
    </dean-tooltip>-->
    <a :class="deanSidemenuColumnItemClass">
      <dean-icon class="icon-custom" :glyph="icon" height="15" width="15"></dean-icon>
      <span><slot></slot></span>
      <dean-icon v-if="!readonly" class="icon-right" :glyph="forward" height="15" width="15"></dean-icon>
    </a>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// SVG
import forward from '../svg/feather-icons/arrow-right.svg';
import empty from '../svg/icons/empty.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';
import deanTooltip from './deanTooltip.vue';

@Component({
  components: {
    deanIcon,
    deanTooltip
  }
})
export default class deanSidemenuColumnItem extends Vue {
  // PROPS
  @Prop({ default: '' }) state!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) active!: boolean;
  @Prop({ default: false }) hidden!: boolean;
  @Prop({
    default: function() {
      return empty;
    }
  })
  icon!: object;

  forward: object = forward;

  //COMPUTED
  get deanSidemenuColumnItemClass() {
    let value = 'link';
    if (!this.disabled && !this.readonly) value += ` enabled`
    if (this.active) value += ` active`
    else if (this.readonly) value += ` readonly`
    else if (this.disabled) value += ` disabled`
    else if (this.state) {
      value += ` ${this.state}`
    }
    if (this.hidden) value += ` hidden`
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN SIDEMENU ITEM
.dean-sidemenu-column-item {
  padding: 5px 10px 5px 10px;

  .tooltip {
    width: 100%;
  }

  .link {
    @include display-flex();
    height: 40px;
    width: 100%;
    padding: 10px;
    text-decoration: none;
    text-align: left;
    //text-transform: lowercase;
    @include transition(all ease 0.8s);
    &:active {
      cursor: default;
    }
    //border-bottom: 1px solid var(--color-light, $color-light);

    .icon-custom {
      align-self: flex-start;
      position: relative;
      margin: 2.5px 10px 2.5px 0px;
    }

    span {
      align-self: flex-start;
      position: relative;
      margin: 2.5px 10px 2.5px 0px;
    }

    .icon-right {
      position: absolute;
      right: 10px;
      margin: 2.5px 10px 2.5px 0px;
    }
  }

  .enabled {
    color: var(--color-link, $color-link);
    font-weight: 500;
    cursor: pointer;
    @include border-radius(10px);
    &:hover,
    &:focus {
      color: var(--color-link, $color-link);
      background: var(--color-light, $color-light);
    }
    .icon-custom {
      fill: var(--color-link, $color-link);
    }
    .icon-right {
      fill: var(--color-link, $color-link);
    }
  }

  .disabled {
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    cursor: not-allowed;
    @include border-radius(10px);
    &:hover,
    &:focus {
      background: none;
    }
    .icon-custom {
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
    }
    .icon-right {
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
    }
  }

  .readonly {
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    font-weight: 500;
    cursor: default;
    @include border-radius(10px);
    .icon-custom {
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
    }
  }


  .active {
    font-weight: 700;
    background: var(--color-light, $color-light);
    color: var(--color-dark, $color-dark);
    @include border-radius(10px);
    .icon-custom {
      fill: var(--color-dark, $color-dark);
    }
    .icon-right {
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
    }
  }

  .hidden {
    display: none;
  }
}

// THEMED
/*
.themed {
  .dean-sidemenu-column-item {
    // THEMING MIXIN
    // @include themify($themes) {
      .enabled {
        color: themed('color-sidemenu-links');
        cursor: pointer;
        &:hover,
        &:focus {
          background: var(--color-light, $color-light);
        }
        .icon-custom {
          fill: themed('color-sidemenu-links');
        }
        .icon-right {
          fill: var(--color-dark-shade-4, $color-dark-shade-4);
        }
      }

      .disabled {
        color: var(--color-dark-shade-4, $color-dark-shade-4);
        cursor: initial;
        &:hover,
        &:focus {
          background: none;
        }
        .icon-custom {
          fill: var(--color-dark-shade-4, $color-dark-shade-4);
        }
        .icon-right {
          fill: var(--color-light, $color-light);
        }
      }

      .active {
        font-weight: 700;
        background: var(--color-light, $color-light);
        color: var(--color-dark-shade-2, $color-dark-shade-2);
        .icon-custom {
          fill: var(--color-dark-shade-2, $color-dark-shade-2)
        }
      }
    // }
  }
}
*/
</style>
